import type { FC, SVGProps } from "react";

/** Glossy accent upload cloud shown inside an empty file dropzone. */
const UploadGlossyIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M28.9759 14.6006C28.3725 13.9762 28.0361 13.0847 28.1353 12.2221C28.2244 11.4482 28.1722 10.6603 27.9769 9.89753C27.6565 8.64579 26.9654 7.51999 25.9945 6.66754C25.0233 5.81509 23.8176 5.27571 22.5349 5.12002C21.6711 5.01518 20.7995 5.08763 19.9721 5.32798C19.248 5.53834 18.4476 5.43372 17.8258 5.00708C16.7454 4.26581 15.4995 3.78754 14.1881 3.61943C12.4585 3.39773 10.703 3.72686 9.17116 4.56003C7.63932 5.39322 6.40909 6.68805 5.65532 8.26048C5.11704 9.38338 4.8413 10.607 4.84048 11.8398C4.8399 12.7004 4.36088 13.5131 3.67056 14.027C3.09359 14.4566 2.60685 15.0035 2.24562 15.6378C1.63686 16.7066 1.42334 17.9555 1.64243 19.1661C1.86151 20.3765 2.49925 21.4713 3.44406 22.259C4.38887 23.0468 5.58059 23.4772 6.81069 23.4749H25.1939C26.3517 23.4786 27.4781 23.0985 28.3968 22.394C29.3156 21.6894 29.9749 20.7002 30.2716 19.5811C30.5685 18.462 30.4859 17.2761 30.0371 16.2088C29.7842 15.6077 29.4231 15.0634 28.9759 14.6006Z"
			fill="url(#upload-glossy-cloud)"
		/>
		<g filter="url(#upload-glossy-blur)">
			<path
				d="M18.1442 26.7484V19.3031H22.5315C22.7596 19.3031 22.8824 19.0353 22.7336 18.8624L17.1199 12.3403C16.7653 11.9282 16.1272 11.9282 15.7725 12.3403L10.1588 18.8624C10.01 19.0353 10.1328 19.3031 10.3609 19.3031H14.7482V26.7484C14.7482 27.6862 15.5085 28.4464 16.4462 28.4464C17.384 28.4464 18.1442 27.6862 18.1442 26.7484Z"
				fill="url(#upload-glossy-arrow)"
			/>
		</g>
		<defs>
			<filter
				id="upload-glossy-blur"
				x="-4.90625"
				y="-2.96875"
				width="42.7031"
				height="46.4152"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feGaussianBlur in="BackgroundImageFix" stdDeviation="7.5" />
				<feComposite
					in2="SourceAlpha"
					operator="in"
					result="effect1_backgroundBlur"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_backgroundBlur"
					result="shape"
				/>
			</filter>
			<linearGradient
				id="upload-glossy-cloud"
				x1="26.2133"
				y1="5.96544"
				x2="10.3872"
				y2="29.588"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#7370FF" />
				<stop offset="1" stopColor="#7370FF" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="upload-glossy-arrow"
				x1="20.9369"
				y1="14.0197"
				x2="7.19345"
				y2="24.9696"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#7370FF" />
				<stop offset="1" stopColor="#7370FF" stopOpacity="0" />
			</linearGradient>
		</defs>
	</svg>
);

export { UploadGlossyIcon };
